var map = {
	"./academy-background.webp": 4687,
	"./academy-banner-1.webp": 624,
	"./academy-banner-2.webp": 8535,
	"./academy-banner-3.webp": 1920,
	"./academy-logo.webp": 9133,
	"./and-more.webp": 5170,
	"./anti-inflammatory.webp": 2102,
	"./banner-1-mobile.webp": 7433,
	"./banner-2-mobile.webp": 1923,
	"./banner-3-mobile.webp": 6393,
	"./bone-health.webp": 4607,
	"./brain-health.webp": 8594,
	"./cancer-prevention.webp": 3912,
	"./choosing-olive-oil.webp": 3327,
	"./dark-bottle.webp": 9583,
	"./diabetes-prevention.webp": 7149,
	"./extra-virgin.webp": 2212,
	"./fresh-olive-oil.webp": 4084,
	"./health-benefits.webp": 3855,
	"./heart-health.webp": 6230,
	"./immune-health.webp": 429,
	"./mental-outlook.webp": 6367,
	"./minimal-time.webp": 5037,
	"./recipes.webp": 1802,
	"./recipes/artichoke-hearts-in-olive-oil.webp": 9859,
	"./recipes/cauliflower-salad-with-pomegranate.webp": 4480,
	"./recipes/italian-pesto-zoodle-salad.webp": 4661,
	"./recipes/menemen.webp": 6102,
	"./recipes/romano-beans-in-olive-oil.webp": 5495,
	"./recipes/strawberry-mint-salad.webp": 2719,
	"./single-estate.webp": 5776,
	"./transportation.webp": 9676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5749;